export const RegexValidation = {
  numberStringRegex: /^\d+$/,
  urlRegex:
    /^(http|https|ftp):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/
};
